import SendWidget from 'components/shared/SendWidget'
import useChat from 'features/chat/hooks/useChat'
import ChatMessengerWidget from 'features/chat/widgets/ChatMessengerWidget'
import { isValidChtCount } from 'features/chat/widgets/ChatMessengerWidget/MinimizedChat'
import useAppControl from 'hooks/useAppControl'
import { FC } from 'react'

const AdminControlPanel: FC = () => {
 const { state } = useChat()
 const { sendWidget, resetSendWidget, chtNotiControl } = useAppControl()

 return (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>
   {((state.chatList && state.chatList.length > 0) ||
    isValidChtCount(chtNotiControl?.count)) && (
    <ChatMessengerWidget
     chtNotiData={chtNotiControl}
     chatList={state.chatList}
    />
   )}

   {sendWidget?.show && (
    <SendWidget
     wFrom={sendWidget.widgetFrom || 'lead'}
     mode={sendWidget.mode}
     to={sendWidget.to}
     type={sendWidget.type}
     onSendSuccess={() => {
      resetSendWidget?.()
     }}
     widget={sendWidget.widget || 'email'}
    />
   )}
  </>
 )
}

export default AdminControlPanel
